import { Link } from 'react-router-dom';

export default function BrandIntro() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left - Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-[2rem] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20space%20with%20warm%20lighting%2C%20a%20single%20laptop%20on%20a%20clean%20wooden%20desk%2C%20indoor%20plant%20in%20corner%2C%20soft%20natural%20light%20from%20window%2C%20warm%20beige%20and%20cream%20tones%2C%20calm%20professional%20atmosphere%2C%20editorial%20interior%20photography%2C%20high%20quality%2C%20clean%20composition%2C%20no%20people%20visible&width=800&height=600&seq=gossip-brand-intro&orientation=landscape"
                alt="吃瓜网品牌介绍"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div className="w-full lg:w-1/2">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-600 text-xs font-semibold mb-4">
              🍉 关于我们
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-4">
              做全网最敢说的
              <br />
              <span className="text-primary-500">吃瓜平台</span>
            </h2>
            <p className="text-foreground-500 text-sm leading-relaxed mb-6">
              吃瓜网成立于2023年，是国内领先的娱乐八卦与爆料内容聚合平台。
              我们秉持"八卦有理，吃瓜无罪"的理念，为用户提供最快、最全、最真实的娱乐圈资讯。
              从明星恋情到网红翻车，从综艺黑幕到行业潜规则，吃瓜网始终站在第一线，
              为吃瓜群众带来最劲爆的第一手瓜源。
            </p>
            <p className="text-foreground-500 text-sm leading-relaxed mb-8">
              我们拥有专业的爆料审核团队和庞大的用户投稿网络，
              确保每一条内容都经过严格的事实核查。吃瓜网不仅是信息平台，
              更是全民参与的娱乐社区——在这里，每个人都可以成为爆料的发起者。
            </p>
            <Link
              to="/about"
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-secondary-100 text-foreground-800 font-medium text-sm hover:bg-secondary-200 transition-colors cursor-pointer"
            >
              了解更多 <i className="ri-arrow-right-up-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}